import { useState } from "react";
import { Typography, TextField, Box, Snackbar, Alert } from "@mui/material";

import WDBox from "../../../MaterialComponents/WDBox";
import BasicLayout from "../../../LayoutContainers/BasicLayout";
import WDButton from "../../../MaterialComponents/WDButton";
import { useNavigate, useSearchParams } from "react-router-dom";

import { Formik, Form, Field } from "formik";
import { object, string, ref } from "yup";
import axios from 'axios';
import AppService from "../../../Configurations/Appservice";
import { formCard, formPanel, rightPanel, rootBox } from "../Login/styles";
import logo from "../../../assets/images/Logo.jpeg";

const ResetPasswordPage = () => {
  const navigate = useNavigate();

  const [searchParams] = useSearchParams();

  const [showError, setShowError] = useState(false);
  const [showSuccess, setShowSuccess] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");

  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }

    setShowError(false);
  };

  const initialValues = {
    email: "",
    password1: "",
    password2: "",
  };

  const validationSchema = object({
    email: string().required("Email id is Mandatory"),
    password1: string().required("Password id is Mandatory"),
    password2: string().required("Password id is Mandatory").oneOf([ref("password1")], "Passwords must match"),
  });

  const [isLoading, loading] = useState(false);

  const [errorMessage, setErrorMessage] = useState();

  const _resetHandler = (values, formikHelpers) => {
    
    loading(true);
    const payload = {
        email: values.email,
        newPassword: values.password1
    };

    AppService.post(`/api/auth/reset-forgot-password?token=${searchParams.get("token")}`, payload)
      .then((response) => {
        console.log(response);
        setSuccessMessage("Password Reset Successfully");
        setShowSuccess(true);
        navigate("/");
      })
      .catch((error) => {
        setErrorMessage("Reset Password request failed ,Please try again");
        setShowError(true);
      })
      .finally(() => {
        loading(false);
      });
  };

    return (
      <BasicLayout>
        <Snackbar open={showError} autoHideDuration={2000} onClose={handleClose}>
          <Alert onClose={handleClose} severity="error" sx={{ width: "100%" }}>
            {errorMessage}
          </Alert>
        </Snackbar>

        <Snackbar open={showSuccess} autoHideDuration={2000} onClose={() => setShowSuccess(false)}>
            <Alert severity="success" sx={{ width: "100%" }}>
                {successMessage}
            </Alert>
        </Snackbar>

        <Box sx={rootBox}>
          <Box sx={formPanel}>
            <Typography color="white.main" sx={{ my: 2 }}>
              Enter Your New Password
            </Typography>
            <Box sx={formCard}>
              <Formik
                initialValues={initialValues}
                onSubmit={_resetHandler}
                validationSchema={validationSchema}
              >
                {({ errors, isValid, touched, dirty }) => (
                  <Form>
                    <WDBox mb={2}>
                        <Field
                        name="email"
                        label="Email Id"
                        fullWidth
                        as={TextField}
                        error={Boolean(errors.email) && Boolean(touched.email)}
                        helperText={Boolean(touched.email) && errors.email}
                        inputProps={{ style: { color: "white" } }}
                        />
                    </WDBox>
                    <WDBox mb={2}>
                        <Field
                        name="password1"
                        label="New Password"
                        fullWidth
                        type={"password"}
                        as={TextField}
                        error={Boolean(errors.password1) && Boolean(touched.password1)}
                        helperText={Boolean(touched.password1) && errors.password1}
                        
                        inputProps={{
                            style: { color: "white" },
                        }}
                        />
                    </WDBox>
                    <WDBox mb={2}>
                        <Field
                        name="password2"
                        label="Confirm New Password"
                        fullWidth
                        type={"password"}
                        as={TextField}
                        error={Boolean(errors.password2) && Boolean(touched.password2)}
                        helperText={Boolean(touched.password2) && errors.password2}
                        
                        inputProps={{
                            style: { color: "white" },
                        }}
                        />
                    </WDBox>
                    <WDButton
                      variant="contained"
                      fullWidth
                      disabled={!dirty || !isValid}
                      type="submit"
                      sx={{ 
                        backgroundColor: '#064d51 !important',
                        '&:hover': { backgroundColor: '#053a3d !important' },
                        color: 'white',
                        fontWeight: 'bold',
                        textTransform: 'uppercase',
                        padding: '10px 0',
                        borderRadius: '4px',
                        boxShadow: '0 4px 6px rgba(0,0,0,0.1)'                       
                      }}
                    >
                      {isLoading ? "Submit..." : "Submit"}
                    </WDButton>
                    <Typography
                      variant="body2"
                      sx={{ mt: 2, textAlign: "center", cursor: "pointer", color: "white.main" }}
                      onClick={() => navigate("/")}
                    >
                      Return to Login
                    </Typography>
                  </Form>
                )}
              </Formik>
            </Box>{" "}
          </Box>
          <Box sx={rightPanel}>
            <Box component="img" src={logo} sx={{ height: "30%", width: "auto" }} />
            {/* <img src={logo} sx={{ height: 10, width: 10 }} /> */}
          </Box>
        </Box>
      </BasicLayout>
    );
};

export default ResetPasswordPage;
